import React from 'react';
import classNames from 'classnames';

// The inside of an action button: an icon filling the button (from
// public/assets/icons) with the label in a strip along the bottom. `turn`
// rotates or mirrors the icon, so the movement arrows can share two images.
export default function ButtonFace({ icon, turn, label }) {
  if (!icon) return label;
  return (
    <>
      <div className={classNames('button-icon', turn)} style={{ backgroundImage: `url('./assets/icons/${icon}.png')` }} />
      <span className="button-label">{label}</span>
    </>
  );
}
